import React from 'react';
import Grid from '@material-ui/core/Grid';

import Container from '@material-ui/core/Container';
import Header from './_header';
import PrefaceSection from './_preface';
import GuardianSection from './_guardians';
import DiscoverSection from './_discover';
import Mobile from './_mobile';
import RegisterSupportSection from './_register-support';


const HomeView = () => {

  return (
    <>
      <Grid
        container
        spacing={0}
      >
        <Header />
        <Mobile />
        <PrefaceSection />
        <GuardianSection />
        <Container maxWidth="lg">
          <DiscoverSection />
        </Container>
        <RegisterSupportSection />
      </Grid>
    </>
  );
}

export default HomeView;
